import script from "./jiaotong-4.vue?vue&type=script&setup=true&lang=js"
export * from "./jiaotong-4.vue?vue&type=script&setup=true&lang=js"

import "./jiaotong-4.vue?vue&type=style&index=0&id=6b595cf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b595cf0"]])

export default __exports__